import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { ScaleLoader } from "react-spinners";
import LoadingOverlay from "react-loading-overlay";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/styles";

const theme = createTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: "Open Sans, Public Sans, Roboto, Poppins, sans-serif",
    },

    palette: {
      contrastThreshold: 2,
      primary: {
        // light: will be calculated from palette.primary.main,
        main: "#0157ae",
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        // light: will be calculated from palette.primary.main,
        main: "#0abb87",
        // dark: will be calculated from palette.primary.main,
        contrastText: "#ffffff",
      },
      error: {
        // light: will be calculated from palette.primary.main,
        main: "#fd397a",
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */
    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        disableRipple: true, // No more ripple, on the whole application 💣!
      },

      // Set default elevation to 1 for popovers.
      MuiPopover: {
        elevation: 1,
      },
    },
  }
);

export default function ThemeProvider(props) {
  const { children } = props;
  const loading = useSelector((values) => values.global.loading, shallowEqual);
  LoadingOverlay.propTypes = undefined;
  return (
    <MuiThemeProvider theme={theme}>
      <LoadingOverlay
        active={loading}
        spinner={<ScaleLoader color="#3694D7" size={50} />}
        styles={{
          wrapper: {
            display: "contents",
          },
        }}
      >
        {children}
      </LoadingOverlay>
    </MuiThemeProvider>
  );
}
